import type { FC } from "react";
import { Container } from "react-bootstrap";
import * as styles from "./styles.module.scss";

const LeftGradient = () => (
    <svg width="190" height="470" viewBox="0 0 190 470" fill="none" xmlns="http://www.w3.org/2000/svg">
        <foreignObject x="-559.737" y="-3.30505" width="749.037" height="504.182">
            <div />
        </foreignObject>
        <g filter="url(#filter0_f_1305_46016)" data-figma-bg-blur-radius="10">
            <path
                d="M-6.61948 126.695L-218.178 214.036L-429.737 301.377L-85.4037 370.877L59.3 311.131L26.9084 220.541L-5.48312 129.952L-6.61948 126.695Z"
                fill="url(#paint0_linear_1305_46016)"
            />
        </g>
        <defs>
            <filter
                id="filter0_f_1305_46016"
                x="-559.737"
                y="-3.30505"
                width="749.037"
                height="504.182"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="65" result="effect1_foregroundBlur_1305_46016" />
            </filter>
            <clipPath id="bgblur_0_1305_46016_clip_path" transform="translate(559.737 3.30505)">
                <path d="M-6.61948 126.695L-218.178 214.036L-429.737 301.377L-85.4037 370.877L59.3 311.131L26.9084 220.541L-5.48312 129.952L-6.61948 126.695Z" />
            </clipPath>
            <linearGradient
                id="paint0_linear_1305_46016"
                x1="-391.93"
                y1="309.008"
                x2="43.0248"
                y2="23.9528"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#00C9FF" />
                <stop offset="1" stop-color="#6800FF" />
            </linearGradient>
        </defs>
    </svg>
);

const RightGradient = () => (
    <svg width="179" height="470" viewBox="0 0 179 470" fill="none" xmlns="http://www.w3.org/2000/svg">
        <foreignObject x="0.666992" y="-10.6256" width="724.109" height="610.759">
            <div />
        </foreignObject>
        <g filter="url(#filter0_f_1305_46019)" data-figma-bg-blur-radius="10">
            <path
                d="M130.667 302.511L362.721 386.322L594.776 470.133L399.077 176.696L240.349 119.374L186.487 209.335L132.624 299.296L130.667 302.511Z"
                fill="url(#paint0_linear_1305_46019)"
            />
        </g>
        <defs>
            <filter
                id="filter0_f_1305_46019"
                x="0.666992"
                y="-10.6256"
                width="724.109"
                height="610.759"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="65" result="effect1_foregroundBlur_1305_46019" />
            </filter>
            <clipPath id="bgblur_0_1305_46019_clip_path" transform="translate(-0.666992 10.6256)">
                <path d="M130.667 302.511L362.721 386.322L594.776 470.133L399.077 176.696L240.349 119.374L186.487 209.335L132.624 299.296L130.667 302.511Z" />
            </clipPath>
            <linearGradient
                id="paint0_linear_1305_46019"
                x1="573.288"
                y1="437.914"
                x2="28.8487"
                y2="268.711"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#00C9FF" />
                <stop offset="1" stop-color="#6800FF" />
            </linearGradient>
        </defs>
    </svg>
);

const LegalHeader: FC<{ title: string; subHeading: string }> = ({ title, subHeading }) => {
    return (
        <div className={[styles.wrapper].join(" ")}>
            <Container>
                <div className={[styles.content_wrapper].join(" ")}>
                    <span className="position-absolute start-0">
                        <LeftGradient />
                    </span>
                    <span className="position-absolute end-0">
                        <RightGradient />
                    </span>
                    <p className={[styles.date, "mb-3"].join(" ")}>Current as of 31 October 2024</p>
                    <h1 className={["figma-h2", "mb-4"].join(" ")}>{title}</h1>
                    <p className={[styles.subheading].join(" ")}>{subHeading}</p>
                </div>
            </Container>
        </div>
    );
};

export default LegalHeader;
